<template>
    <div class='py-2 pr-2 flex justify-center items-center'>
      <!-- 移動到頂部 -->
      <a v-if="showMoveButtons" 
         @click.prevent="$emit('moveToTop')" 
         class="group relative flex justify-center items-center w-6 h-6 m-1.5 cursor-pointer to-top">
        <img src="../../images/icons/upload2.svg" class="object-contain"/>
        <div class="tooltip-top invisible group-hover:visible absolute bg-grey-1 text-white text-xs py-1 px-2 rounded whitespace-nowrap top-full left-1/2 -translate-x-1/2 mt-1">
          {{ $t('models.index.to_top') }}
        </div>
      </a>
  
      <!-- 移動到底部 -->
      <a v-if="showMoveButtons" 
         @click.prevent="$emit('moveToBottom')" 
         class="group relative flex justify-center items-center w-4.5 h-4.5 m-1.5 cursor-pointer to-bottom">
        <img src="../../images/icons/download.svg" class="object-contain"/>
        <div class="tooltip-bottom invisible group-hover:visible absolute bg-grey-1 text-white text-xs py-1 px-2 rounded whitespace-nowrap top-[116%] left-1/2 -translate-x-1/2 mt-1">
          {{ $t('models.index.to_bottom') }}
        </div>
      </a>
  
      <!-- Pin 按鈕 -->
      <a v-if="showPinIcon" 
         @click.prevent="$emit('togglePin')" 
         class="flex justify-center items-center w-6 h-6 m-1.5 cursor-pointer hover:brightness-[110%] hover:contrast-[95%]">
        <img :src="pinIconSrc" class="object-contain" :alt="isPinned ? 'Unpin' : 'Pin'"/>
      </a>
    </div>
  </template>
  
  <script>
  import { defineComponent, computed } from 'vue';
  
  export default defineComponent({
    name: 'SortedActionButtons',
    props: {
      orderType: {
        type: String,
        required: true
      },
      showPinIcon: {
        type: Boolean,
        default: true
      },
      isPinned: {
        type: Boolean,
        default: false
      }
    },
    emits: ['moveToTop', 'moveToBottom', 'togglePin'],
    
    setup(props) {
      const showMoveButtons = computed(() => props.orderType === 'custom_order');
      
      const pinIconSrc = computed(() => 
        props.isPinned 
          ? require('../../images/icons/icon_star_yellow.svg')
          : require('../../images/icons/icon_star_yellow_empty.svg')
      );
  
      return {
        showMoveButtons,
        pinIconSrc
      };
    }
  });
  </script>